import Vue from 'vue'
import appState from 'lib/appState'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'
import stickyfill from 'stickyfill'
import Cart from 'lib/cart'
import 'modules/cart-item/cart-item.vue'
import 'modules/quantity-selector/quantity-selector.vue'
import 'modules/image/image.vue'
import 'modules/shipping-calculator/shipping-calculator.vue'
import 'modules/free-gift/free-gift.vue'
import 'modules/cart-related-products/cart-related-products.vue'
import 'modules/cart-promo-code/cart-promo-code.vue'

Vue.component('cart-grid', {
  props: [
    'type',
    'minPrice',
    'variantId'
  ],
  computed: {
    ...mapGetters(['subtotal']),
    ...mapState([
      'app',
      'loading',
      'isBootstrapped',
      'isMobile'
    ]),
    isEmpty () {
      return this.cart.items.length === 0
    },
    cart () {
      return this.app.cart
    },
    ...mapGetters([
      'subscriptions',
      'purchases',
      'purchasesTotal',
      'subscriptionTotal',
      'giftMessageEdited',
      'bundles'
    ]),
    cartValid () {
      if (this.bundleError) return false
      return true
    },
    bundleError () {
      const bundles = Object.values(this.bundles)
      return bundles.some((bundle) => {
        const total = bundle.reduce((t, { quantity }) => t + quantity, 0)
        return total < 3
      })
    },
    hasPreOrderInCart () {
      if (appState.cartMeta && appState.cartMeta.length > 0) {
        return appState.cartMeta.some((item) => item.tags.includes('PREORDER'))
      }
      return false
    }
  },
  watch: {
    'app.isMiniCartOpen' (value) {
      if (value) {
        disableBodyScroll(this.$refs['cart'])
      } else {
        clearAllBodyScrollLocks()
      }
    }
  },
  methods: {
    ...mapMutations(['bootstrap', 'toggleMiniCart']),
    ...mapActions(['saveGiftMessage']),
    async handleCheckoutRequest () {
      if (this.giftMessageEdited) {
        await this.saveGiftMessage()
      }
      Cart.gotoCheckout()
    },
    focusOut () {
      this.app.isMiniCartOpen = false
    }
  },
  mounted () {
    this.bootstrap()
    const cartSide = this.$refs.cartside
    if (this.type === 'code') {
      this.app.freeGiftType = this.type
      this.app.freeGiftGoal = this.minPrice
      this.app.freeGiftVariantId = this.variantId
    }
    if (cartSide) {
      const stickyPolyfill = stickyfill()
      stickyPolyfill.add(cartSide)
    }
  }
})
